import { authSlice } from '@wellesley/auth'
import { useDispatch, useSelector } from 'react-redux'
import { useGetApiV1NotificationsQuery } from '../../api'
import { useEffect, useState } from 'react'
import { notificationsSlice } from '../../slice'
import { userSlice } from '@wellesley/user'
import { resetNotificationsState } from '@wellesley/host-remote/api/actions'

const ITEMS_PER_PAGE = 20

type HookProps = {
  limit?: number
}

const useFetchNotifications = ({ limit = ITEMS_PER_PAGE }: HookProps) => {
  const [page, setPage] = useState(1)
  const dispatch = useDispatch()

  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)
  const notificationsOwner = useSelector(
    notificationsSlice.selectors.selectNotificationsOwner,
  )

  const { refetch, isUninitialized, isLoading, isFetching, isSuccess } =
    useGetApiV1NotificationsQuery(
      { limit, offset: (page - 1) * limit },
      {
        skip: !isLogged,
      },
    )

  const refetchNotification = () => {
    if (isUninitialized || isLoading || isFetching || !isSuccess) return

    dispatch(resetNotificationsState())
    void refetch()
  }

  useEffect(() => {
    if (!notificationsOwner || !currentUser) return

    const canRefetch = notificationsOwner !== currentUser.id

    canRefetch && refetchNotification()
  }, [currentUser?.id, notificationsOwner])

  const loadMore = () => setPage((page) => page + 1)

  return { loadMore, isLoading }
}

export default useFetchNotifications
